import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

import axios from "axios";

Vue.use(Router);
let router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: {
        requireLogin: true
      },
      // redirect: "/classlist",
      children: [
        {
          path: "/classlist",
          name: "classlist",
          component: () =>
            import("./views/ClassList.vue"),
            // meta: {
            //   keepAlive: true
            // }
        },
        {
          path: "/mobileclasslist",
          name: "mobileclasslist",
          component: () =>import( "./views/MobileClassList.vue"),
        },
        {
          path: "/user",
          name: "user",
          component: () =>import("./views/UserCenter.vue"),
          children: [
            {
              path: "userinfo",
              name: "userinfo",
              component: () =>
                import("./components/usercenter/UserInfo.vue")
            },
            {
              path: "starcurr",
              name: "starcurr",
              component: () =>
                import("./components/usercenter/StarCurrency.vue")
            },
            {
              path: "stardetails",
              name: "stardetails",
              component: () =>
                import("./components/usercenter/StarDetails.vue")
            },
            {
              path: "setting",
              name: "setting",
              component: () =>
                import("./components/usercenter/Setting.vue")
            }
          ]
        }
      ]
    },
    {
      path: "/classhome",
      name: "classhome",
      component: () => import("./views/ClassHome.vue"),
      redirect: "main",
      meta: {
        requireLogin: true
      },
      children: [
        {
          path: "/recordhome",
          name: "main",
          component: () =>
            import("./views/ClassMain.vue")
        },
        {
          path: "recordworks/:id",
          name: "works",
          component: () =>
            import("./views/WorksShow.vue")
        }
      ]
    },
    {
      path: "/",
      name: "login",
      redirect: "loginindex",
      component: () =>
      import(/* webpackChunkName: "about" */ "./views/Login.vue"),
      children: [
        {
          path: "loginindex",
          name: "loginindex",
          component: () =>
            import(/* webpackChunkName: "about" */ "./components/login/LoginIndex.vue")
        },
        {
          path: "mobilelogin",
          name: "mobilelogin",
          component: () =>
            import(/* webpackChunkName: "about" */ "./components/login/mobileLogin.vue"),
          meta:{
              title: "登录"
          }
        },
        {
          path: "ipadindex",
          name: "ipadindex",
          component: () =>
            import(/* webpackChunkName: "about" */ "./components/login/ipadLogin.vue")
        },
        {
          path: "changepasswd",
          name: "changepasswd",
          component: () =>
            import(/* webpackChunkName: "about" */ "./components/login/ChangePasswd.vue")
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  console.log(to.matched)
  if (to.matched.some(record => record.meta.requireLogin)) {
    axios.get("/whoami").then((res) => {
      if(res.data.mobile){
        next();
      }else{
        router.push({ path: '/loginindex', query: { redirect: to.fullPath }});
      }
    }).catch((error) => {
      console.log(error);
    });
  } else {
    console.log('啦啦啦')
    axios.get("/whoami").then((res) => {
      // console.log(res.data);
      if(res.data.mobile){
        if(to.fullPath==="/changepasswd"){
          next();
        }else{
          router.push({ path: '/classlist', query: { redirect: to.fullPath }});
        }
      }else{
        next();
      }
    }).catch((error) => {
      console.log(error);
    });
  }
});

export default router;
